import {ServiceInterface} from '@/types/ServiceInterface'
import dayjs from 'dayjs'
import ServiceRepository from '@/repositories/ServiceRepository'
import {LocationType} from '@/types/LocationType'
import {Applicant} from '@/types/Applicant'
import { Metadata } from '@/types/Metadata'
import {useWpClientsStore} from "@/services/stores/WpClientStore";
import { useSettingsStore } from '@/services/stores/SettingsStore'
import User from './User'
import UserRepository from '@/repositories/UserRepository'

export default class Service implements ServiceInterface {
  id: string
  status: string
  start_loc: LocationType
  end_loc: LocationType | null = null
  phone: string
  name: string
  amount: number | null = null
  applicants: Applicant | null = null
  metadata: Metadata | null = null
  wp_client_id: string
  driver_id: string | null = null
  client_id: string | null = null
  created_at: number
  comment: string | null = null
  a_go = 0
  client_completed_services_count: number | null = null
  deducted_value: number | null = null
  created_by: string | null = null
  origin: string | null = null
  directed_to: string | null = null
  assigned_by: string | null = null
  canceled_by: string | null = null
  terminated_by: string | null = null
  vehicle: {
    plate: string
    brand?: string | null
    model?: string | null
    color?: { name?: string; hex?: string } | null
  } | null = null

  static readonly STATUS_PENDING = 'pending'
  static readonly STATUS_IN_PROGRESS = 'in_progress'
  static readonly STATUS_TERMINATED = 'terminated'
  static readonly STATUS_CANCELED = 'canceled'
  static readonly ORIGIN_ADMIN = 'admin'
  static readonly ORIGIN_BOT = 'bot'
  static readonly ORIGIN_TEST = 'test'
  static readonly ORIGIN_DRIVER = 'driver'
  // Must stay in sync with the literal written by the api at
  // api/src/Api/Controllers/Drivers/DriverAppController.ts:625 (startLoc.name for self-service trips).
  static readonly SELF_SERVICE_START_LOC_NAME = 'Self service trip'
  static readonly EVENT_CANCEL = 'cancel-service'
  static readonly EVENT_TERMINATE = 'end-service'
  static readonly EVENT_SHOW = 'show-service'
  static readonly EVENT_ASSIGN = 'assign-service'
  static readonly EVENT_RELEASE = 'release-service'
  static readonly EVENT_RESTART = 'restart-service'


  constructor() {
    const { defaultClient } = useWpClientsStore()
    this.id = dayjs().unix().toString()
    this.created_at = dayjs().unix()
    this.status = Service.STATUS_PENDING
    this.wp_client_id = defaultClient as string
  }

  isPending(): boolean {
    return this.status === Service.STATUS_PENDING
  }

  isInProgress(): boolean {
    return this.status === Service.STATUS_IN_PROGRESS
  }

  isEnd(): boolean {
    return this.status === Service.STATUS_CANCELED || this.status === Service.STATUS_TERMINATED
  }

  async update(data: ServiceInterface): Promise<Service> {
    await ServiceRepository.update(data)
    return this
  }

  async assign(driverId: string): Promise<void> {
    await ServiceRepository.assign(this.id, driverId)
  }

  async getCreatedBy(): Promise<User| null> {
		return this.created_by ? UserRepository.getUserById(this.created_by) : null
	}

	async getCanceledBy(): Promise<User| null>  {
		return this.canceled_by ? UserRepository.getUserById(this.canceled_by) : null
	}

	async getTerminatedBy(): Promise<User| null> {
		return this.terminated_by ? UserRepository.getUserById(this.terminated_by) : null
	}

	async getAssignedBy(): Promise<User| null>  {
		return this.assigned_by ? UserRepository.getUserById(this.assigned_by) : null
	}
}
